export const NAV = {
  logo: "nav-logo",
  linkHome: "nav-link-home",
  linkAbout: "nav-link-about",
  linkShop: "nav-link-shop",
  linkWholesale: "nav-link-wholesale",
  linkContact: "nav-link-contact",
  mobileToggle: "nav-mobile-toggle",
  mobilePanel: "nav-mobile-panel",
};

export const HOME = {
  heroHeading: "home-hero-heading",
  heroCta: "home-hero-cta",
  marquee: "home-marquee",
  pillarShop: "pillar-shop",
  pillarAbattoir: "pillar-abattoir",
  pillarWholesale: "pillar-wholesale",
  manifestoSection: "home-manifesto",
  storySection: "home-story",
};

export const SHOP = {
  root: "shop-root",
  categoryCard: (slug) => `shop-cat-${slug}`,
  callBtn: "shop-call-btn",
};

export const CONTACT = {
  form: "contact-form",
  inputName: "contact-input-name",
  inputEmail: "contact-input-email",
  inputPhone: "contact-input-phone",
  inputSubject: "contact-input-subject",
  inputMessage: "contact-input-message",
  submit: "contact-submit",
  success: "contact-success",
  error: "contact-error",
};

export const WHOLESALE = {
  form: "wholesale-form",
  inputName: "wholesale-input-name",
  inputEmail: "wholesale-input-email",
  inputPhone: "wholesale-input-phone",
  inputSubject: "wholesale-input-subject",
  inputMessage: "wholesale-input-message",
  submit: "wholesale-submit",
};

export const FOOTER = {
  root: "site-footer",
  pdfLink: (slug) => `footer-pdf-${slug}`,
};
